import React, { useState, useEffect } from 'react'
import { useInput } from '../../../hooks/useInput'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import FormContainer from '../../Form/FormContainer'
import { Button, Grid } from '@material-ui/core'
import { resetUserPassword } from '../../../actions/userActions'
import { USER_UPDATE_PASSWORD_RESET } from '../../../constants/userConstants'
import TextInput from '../../Form/TextInput'
import { usePasswordValidator } from '../../../hooks/usePasswordValidator'
import { Visibility, VisibilityOff } from '@material-ui/icons'

const ResetPassword = ({ match }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [passwordError, setPasswordError] = useState('')
  const confirmationCode = match.params.code
  const { value: password, bind: bindPassword } = useInput('')
  const { value: confirmPassword, bind: bindConfirmPassword } = useInput('')
  const passwordIsValid = usePasswordValidator(password)
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const { loading, success } = useSelector((state) => state.userResetPassword)

  useEffect(() => {
    if (success) {
      dispatch({ type: USER_UPDATE_PASSWORD_RESET })
      history.push('/password-reset')
    }
  }, [dispatch, success, history])

  const submitHandler = (e) => {
    e.preventDefault()
    setPasswordError('')

    let ready = true

    if (password !== confirmPassword) {
      setPasswordError('Passwords do not match')
      ready = false
    }

    if (passwordIsValid !== '') {
      ready = false
      setPasswordError(passwordIsValid)
    }

    if (ready) {
      dispatch(resetUserPassword(password, confirmationCode))
    }
  }

  return (
    <div className="login flex">
      <div
        className="bg-image"
        style={{ backgroundImage: "url('/images/login-bg.jpg')" }}
      ></div>
      <FormContainer>
        <form onSubmit={submitHandler}>
          <h2>Password Reset</h2>
          <p className="fs14">
            Create a new password for your MyQuality account following these
            password requirements:
          </p>
          <ul className="p-l-40 fs14 m-b-20">
            <li>At least 8 characters</li>
            <li>Upper and lowercase letters</li>
            <li>Inclusion of at least one special character</li>
          </ul>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextInput
                name="password"
                label="Enter password"
                bindValue={bindPassword}
                error={passwordError}
                type={showPassword ? 'text' : 'password'}
                endAdornment={true}
                handleClick={() => setShowPassword(!showPassword)}
                icon={showPassword ? <VisibilityOff /> : <Visibility />}
              />
            </Grid>

            <Grid item xs={12}>
              <TextInput
                name="confirmPassword"
                label="Enter password"
                bindValue={bindConfirmPassword}
                error={passwordError}
                type={showConfirmPassword ? 'text' : 'password'}
                endAdornment={true}
                handleClick={() => setShowConfirmPassword(!showConfirmPassword)}
                icon={showConfirmPassword ? <VisibilityOff /> : <Visibility />}
              />
            </Grid>
          </Grid>

          <div className="flex flex-end m-t-20">
            <Button
              variant="outlined"
              color="primary"
              onClick={() => history.push('/login')}
              className="m-r-25"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={password === '' || confirmPassword === '' || loading}
            >
              Reset Password
            </Button>
          </div>
        </form>
      </FormContainer>
    </div>
  )
}

export default ResetPassword
